export const BASE_ROUTE = "/";
export const FORGOT = "/forgot-password"
export const RESET = "/reset-password"
export const DASHBOARD = "/dashboard"
export const PATIENTS = "/patients"
export const ADD_PATIENT = "/patients/add-patient"
export const NOT_FOUND = "*"